export const NavbarLinks = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "Catalog",
    // path: '/catalog',
  },
  {
    title: "FMGE through AI",
     path: "/fmge-through-ai",
  },
  {
    title: "Abroad Education",
  },
  {
    title: "About Us",
    path: "/about",
  },
  {
    title: "Contact Us",
    path: "/contact",
  },
  {
    title: "Blogs",
    path: "/blogs",
  },
];